export let daYanArray = [
     1,  2,  3,  4,  5,  6,  7,  8,  9, 10,
    11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
    31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50
];

export let daYanNumberArray = [
    {
        oid: 1,
        nid: 1,
        inBunndle: true
    },
    {
        oid: 2,
        nid: 2,
        inBunndle: true
    },
    {
        oid: 3,
        nid: 3,
        inBunndle: true
    },
    {
        oid: 4,
        nid: 4,
        inBunndle: true
    },
    {
        oid: 5,
        nid: 5,
        inBunndle: true
    },
    {
        oid: 6,
        nid: 6,
        inBunndle: true
    },
    {
        oid: 7,
        nid: 7,
        inBunndle: true
    },
    {
        oid: 8,
        nid: 8,
        inBunndle: true
    },
    {
        oid: 9,
        nid: 9,
        inBunndle: true
    },
    {
        oid: 10,
        nid: 10,
        inBunndle: true
    },
    {
        oid: 11,
        nid: 11,
        inBunndle: true
    },
    {
        oid: 12,
        nid: 12,
        inBunndle: true
    },
    {
        oid: 13,
        nid: 13,
        inBunndle: true
    },
    {
        oid: 14,
        nid: 14,
        inBunndle: true
    },
    {
        oid: 15,
        nid: 15,
        inBunndle: true
    },
    {
        oid: 16,
        nid: 16,
        inBunndle: true
    },
    {
        oid: 17,
        nid: 17,
        inBunndle: true
    },
    {
        oid: 18,
        nid: 18,
        inBunndle: true
    },
    {
        oid: 19,
        nid: 19,
        inBunndle: true
    },
    {
        oid: 20,
        nid: 20,
        inBunndle: true
    },
    {
        oid: 21,
        nid: 21,
        inBunndle: true
    },
    {
        oid: 22,
        nid: 22,
        inBunndle: true
    },
    {
        oid: 23,
        nid: 23,
        inBunndle: true
    },
    {
        oid: 24,
        nid: 24,
        inBunndle: true
    },
    {
        oid: 25,
        nid: 25,
        inBunndle: true
    },
    {
        oid: 26,
        nid: 26,
        inBunndle: true
    },
    {
        oid: 27,
        nid: 27,
        inBunndle: true
    },
    {
        oid: 28,
        nid: 28,
        inBunndle: true
    },
    {
        oid: 29,
        nid: 29,
        inBunndle: true
    },
    {
        oid: 30,
        nid: 30,
        inBunndle: true
    },
    {
        oid: 31,
        nid: 31,
        inBunndle: true
    },
    {
        oid: 32,
        nid: 32,
        inBunndle: true
    },
    {
        oid: 33,
        nid: 33,
        inBunndle: true
    },
    {
        oid: 34,
        nid: 34,
        inBunndle: true
    },
    {
        oid: 35,
        nid: 35,
        inBunndle: true
    },
    {
        oid: 36,
        nid: 36,
        inBunndle: true
    },
    {
        oid: 37,
        nid: 37,
        inBunndle: true
    },
    {
        oid: 38,
        nid: 38,
        inBunndle: true
    },
    {
        oid: 39,
        nid: 39,
        inBunndle: true
    },
    {
        oid: 40,
        nid: 40,
        inBunndle: true
    },
    {
        oid: 41,
        nid: 41,
        inBunndle: true
    },
    {
        oid: 42,
        nid: 42,
        inBunndle: true
    },
    {
        oid: 43,
        nid: 43,
        inBunndle: true
    },
    {
        oid: 44,
        nid: 44,
        inBunndle: true
    },
    {
        oid: 45,
        nid: 45,
        inBunndle: true
    },
    {
        oid: 46,
        nid: 46,
        inBunndle: true
    },
    {
        oid: 47,
        nid: 47,
        inBunndle: true
    },
    {
        oid: 48,
        nid: 48,
        inBunndle: true
    },
    {
        oid: 49,
        nid: 49,
        inBunndle: true
    },
    {
        oid: 50,
        nid: 50,
        inBunndle: true
    }
]